import type { GridRowId, GridRowTreeConfig } from "@mui/x-data-grid-premium";

interface GroupExpansionScope {
  groupIds: GridRowId[];
  expanded: boolean;
}

export const getGroupExpansionScope = (
  rowTree: GridRowTreeConfig,
  rowIds: GridRowId[],
  depth: number
): GroupExpansionScope => {
  const groupIds: GridRowId[] = [];
  let expanded = false;
  if (depth < 0) {
    return { groupIds, expanded };
  }
  for (const id of rowIds) {
    const node = rowTree[id];
    if (node?.type !== "group" || node.depth < depth) {
      continue;
    }
    groupIds.push(id);
    if (node.depth === depth && node.childrenExpanded) {
      expanded = true;
    }
  }
  return { groupIds, expanded };
};
